export function getMostSignificantDigit(value: number): number {
  if (value === 0) {
    return 0;
  }

  if (!Number.isFinite(value)) {
    return NaN;
  }

  // For numbers very close to 0 (powers -323 to -312)
  // Math.log10() returns value that is just a bit too small. To correct for that, we
  // always double-check the next power of 10.
  const exponent = Math.floor(Math.log10(Math.abs(value)));
  return Math.pow(10, exponent + 1) <= value ? exponent + 1 : exponent;
}
